import React, { FunctionComponent, useEffect, useMemo } from 'react';
import { useStore } from 'effector-react';
import SpamList from '@components/SpamList';
import SpamFilters from '@components/SpamFilters';
import SpamPageLayout from '@components/SpamPageLayout';
import useSpamFilters from '@hooks/useSpamFilters';
import localeWeightStore, { resetLocaleWeight, DEFAULT_LOCALE_WEIGHT } from '@stores/localeWeight';
import { reset as resetSpam } from '@stores/spam';

interface SpamRouteProps {}

const SpamRoute: FunctionComponent<SpamRouteProps> = () => {
  const { spam, getById, getList } = useSpamFilters();
  const { filters } = useStore(spam);
  const locale = useStore(localeWeightStore);

  useEffect(() => {
    const { id } = filters;

    if (id) {
      getById(id);
    } else {
      getList();
    }

    return () => {
      resetSpam();
      resetLocaleWeight();
    };
  }, []);

  const hasActiveFilters = useMemo(() => {
    return Boolean(
      filters.id || filters.author || filters.needChecked || locale !== DEFAULT_LOCALE_WEIGHT,
    );
  }, [filters, locale]);

  return (
    <SpamPageLayout
      filters={<SpamFilters />}
      hasActiveFilters={hasActiveFilters}
    >
      <SpamList />
    </SpamPageLayout>
  );
};

export default SpamRoute;
